import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { Module, useGetAccountQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard',
  setup: function setup(__props) {
    var _useGetAccountQuery = useGetAccountQuery(),
      result = _useGetAccountQuery.result,
      loading = _useGetAccountQuery.loading;
    var companies = computed(function () {
      var _result$value, _result$value$getAcco;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$getAcco = _result$value.getAccount.ventureLinks) === null || _result$value$getAcco === void 0 ? void 0 : _result$value$getAcco.filter(function (ventureLink) {
        var _ventureLink$modules;
        return (_ventureLink$modules = ventureLink.modules) === null || _ventureLink$modules === void 0 ? void 0 : _ventureLink$modules.includes(Module.Esg);
      });
    });
    var impactGoalAssessments = computed(function () {
      var _result$value2, _result$value2$getAcc;
      return (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : (_result$value2$getAcc = _result$value2.getAccount.ventureLinks) === null || _result$value2$getAcc === void 0 ? void 0 : _result$value2$getAcc.filter(function (ventureLink) {
        var _ventureLink$modules2;
        return (_ventureLink$modules2 = ventureLink.modules) === null || _ventureLink$modules2 === void 0 ? void 0 : _ventureLink$modules2.includes(Module.ImpactGoal);
      });
    });
    var hasMetricsModule = computed(function () {
      var _result$value3, _result$value3$getAcc;
      return (_result$value3 = result.value) === null || _result$value3 === void 0 ? void 0 : (_result$value3$getAcc = _result$value3.getAccount.ventureLinks) === null || _result$value3$getAcc === void 0 ? void 0 : _result$value3$getAcc.find(function (ventureLink) {
        return ventureLink.modules.includes(Module.Metrics);
      });
    });
    var noVentures = computed(function () {
      var _result$value4, _result$value4$getAcc, _result$value4$getAcc2;
      return !((_result$value4 = result.value) !== null && _result$value4 !== void 0 && (_result$value4$getAcc = _result$value4.getAccount) !== null && _result$value4$getAcc !== void 0 && (_result$value4$getAcc2 = _result$value4$getAcc.ventureLinks) !== null && _result$value4$getAcc2 !== void 0 && _result$value4$getAcc2.length);
    });
    return {
      __sfc: true,
      result: result,
      loading: loading,
      companies: companies,
      impactGoalAssessments: impactGoalAssessments,
      hasMetricsModule: hasMetricsModule,
      noVentures: noVentures
    };
  }
});